import { onError } from "@apollo/client/link/error";
import { toast } from "react-toastify";

export const errorLink = onError(
  ({ graphQLErrors, networkError, protocolErrors }) => {
    if (graphQLErrors) {
      console.error(`graphQLErrors:`, graphQLErrors);
      toast.error(graphQLErrors[0].message);
    }

    if (networkError) {
      console.error(`networkError:`, networkError.result);
      if (networkError.statusCode === 401) {
        toast.error("Unauthenticated");
        localStorage.removeItem("user_information");
        localStorage.removeItem("isUserDataSet");
        window.location.href = "/login";
      }
    }
  }
);
